import React from 'react';
import { MailIcon, MessageCircleIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-fil-cocoa text-fil-card py-10 sm:py-12 px-4 text-center" data-id="element-55" data-mp="3gfsn6dua2wni">
      <div className="max-w-4xl mx-auto flex flex-col items-center gap-3" data-id="element-56" data-mp="32nuhkczrziw3">
        <p className="font-serif text-2xl font-bold tracking-wide" data-id="element-57" data-mp="32lrmhejrmzki">
          Deco Emprende
        </p>
        <h2 className="font-serif text-sm sm:text-base text-fil-card/80 font-normal tracking-wide" data-id="element-58" data-mp="36n3dnoiafsut">
          El Arte de la Filigrana · Producto 100% digital
        </h2>

        <div className="w-12 h-px bg-fil-card/25 my-3" data-id="element-59" data-mp="387ejk1577e7" />

        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm" data-id="element-60" data-mp="3levgj10wbefn">
          
          
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-fil-card/60 mt-2" data-id="element-61" data-mp="3qc3zh3tvbmhy">
          <a href="#terminos" className="hover:text-white transition-colors duration-150 ease-out" data-id="element-62" data-mp="29xvps9u757nq">
            Términos y condiciones
          </a>
          <a href="#privacidad" className="hover:text-white transition-colors duration-150 ease-out" data-id="element-63" data-mp="3l90lvqkngowm">
            Política de privacidad
          </a>
        </div>

        <p className="text-fil-card/50 text-xs mt-3" data-id="element-64" data-mp="3gck1n7gkmuot">
          © {new Date().getFullYear()} Deco Emprende. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}